import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Renders one row per product in a per-seller cart order.
 *
 * Cart line items all share the `line-item/item` code and carry no product name, so the products
 * are read from the transaction's `protectedData.cartItems` (enriched server-side with title and
 * unit price). Each row shows "{title} x {quantity}" and the line total.
 *
 * @component
 * @param {Object} props
 * @param {Array<{listingId: string, title: string, quantity: number, pricingOptionName: string, unitPrice: {amount: number, currency: string}}>} props.cartItems
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element|null}
 */
const LineItemCartItemsMaybe = props => {
  const { cartItems, intl } = props;

  if (!Array.isArray(cartItems) || cartItems.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      {cartItems.map((item, i) => {
        const { title, quantity, unitPrice, pricingOptionName } = item;
        const lineTotal =
          unitPrice && Number.isFinite(unitPrice.amount)
            ? new Money(unitPrice.amount * quantity, unitPrice.currency)
            : null;
        const unitPriceMoney =
          unitPrice && Number.isFinite(unitPrice.amount)
            ? new Money(unitPrice.amount, unitPrice.currency)
            : null;

        const name = pricingOptionName ? `${title} – ${pricingOptionName}` : title;
        const label = unitPriceMoney
          ? `${name} ${formatMoney(intl, unitPriceMoney)} x ${quantity}`
          : `${name} x ${quantity}`;

        return (
          <div key={`${i}-${item.listingId}`} className={css.lineItem}>
            <span className={css.itemLabel}>{label}</span>
            <span className={css.itemValue}>{lineTotal ? formatMoney(intl, lineTotal) : ''}</span>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default LineItemCartItemsMaybe;
